/* eslint-disable no-console */
const textWrapperReducer = (state, action) => {
	switch (action.type) {
		case 'fetchLetter':
			return {
				...state,
				letterData: action.payload,
				letterId: action.payload.letterId,
			};
		case 'setCaret':
			return {
				...state,
				caret: action.payload,
			};
		case 'hidePopoup':
			return {
				...state,
				caret: null,
				popoverMode: 0,
			};

		case 'setTempCaret':
			return {
				...state,
				tempCaret: action.payload,
			};
		case 'setPopoverPosition':
			return {
				...state,
				popoverPosition: action.popoverPosition,
			};
		case 'setPopoverDisablePointerEvents':
			// when mouse is down to selection works smoothly it has to pointerEvents:none
			return {
				...state,
				popoverDisablePointerEvents: action.payload.popoverDisablePointerEvents,
			};

		case 'highlightText':
			if (action.payload) {
				return {
					...state,
					letterData: {
						...state.letterData,
						originalDoc: {
							...state.letterData.originalDoc,
							content: action.payload.content,
						},
					},
				};
			} else {
				return { ...state };
			}

		case 'clearHighlightText':
			if (action.payload) {
				return {
					...state,
					letterData: {
						...state.letterData,
						originalDoc: {
							...state.letterData.originalDoc,
							content: action.payload.content,
						},
					},
					caret: { start: 0, end: 0, text: '' },
				};
			} else {
				return { ...state };
			}

		case 'handleChangeConfirmed':
			if (action.payload) {
				return {
					...state,
					letterData: {
						...state.letterData,
						originalDoc: action.payload.originalDoc,
						simplifiedDoc: action.payload.simplifiedDoc,
						version: action.payload.version,
					},
					// eventObject: { type: 'changeAdded' },
					// then close popup
					caret: (action.payload.newChange ? null : state.caret),
					popoverMode: (action.payload.newChange ? 0 : state.popoverMode),
					// if new change is added to existing change, reload history in LetterLogin
					eventObject: (action.payload.newChange ? null : { type: 'reloadHistory', payload: { changeId: action.payload.changeId } }),
					historyIsLoading: false,
				};
			} else {
				return { ...state };
			}

		case 'handleChangeEditConfirmed':
			console.log('handle change edit confirmed');
			return {
				...state,
				letterData: {
					...state.letterData,
					originalDoc: action.payload.originalDoc,
					simplifiedDoc: action.payload.simplifiedDoc,
					version: action.payload.version,
				},
				eventObject: { type: 'editAdded' },
				requestPending: false,
			};

		case 'historyIsLoading':
			return {
				...state,
				historyIsLoading: true,
			};

		case 'loadChangesHistory':
			if (action.payload) {
				return {
					...state,
					currentChangesHistory: action.payload,
					historyIsLoading: false,
				};
			} else {
				return state;
			}

		case 'resetChangesHistory':
			return {
				...state,
				currentChangesHistory: null,
				popoverMode: 0,
			};

		case 'setPopoverMode':
			return {
				...state,
				popoverMode: action.payload.popoverMode,
			};
		case 'setAddToExistingMode':
			return {
				...state,
				addToExistingMode: action.payload.addToExistingMode,
			};
		case 'setIsMobile':
			return {
				...state,
				isMobile: action.payload.isMobile,
			};

			// show modal for user to confirm the deletion of change
		case 'showModalDeleteChange':
			return {
				...state,
				eventObject: {
					type: 'showModalDeleteChange',
					changeId: action.payload.changeId,
				},
			};
			// user has confirmed the deletion, api has also done it successfully
		case 'deleteChange':
			// const chn = state.currentChangesHistory.changes.filter(el => el.id !== action.payload.changeId);

			// delete removed change from current changes history. If there is no changes left - change popover mode on 0 to hide popover

			return {
				// ...state,
				// letterData: {
				//     ...state.letterData,
				//     originalDoc: action.payload.originalDoc,
				//     simplifiedDoc: action.payload.simplifiedDoc,
				// },
				// currentChangesHistory: (chn.length ? {
				//     ...state.currentChangesHistory, changes: chn
				// } : null),
				// popoverMode: (chn.length ? 2 : 0),
				// currentSelectedChangeId: (chn.length ? chn[0].id : null)
				...state,
				letterData: {
					...state.letterData,
					autoChanges: action.payload.autoChanges,
					originalDoc: action.payload.originalDoc,
					simplifiedDoc: action.payload.simplifiedDoc,
					version: action.payload.version,
				},
				currentSelectedChangeId: 0,
				addToexistingMode: false,
				currentChangesHistory: null,
				popoverMode: 0,
			};

		case 'setCurrentSelectedChangeId':
			return {
				...state,
				currentSelectedChangeId: action.payload.changeId,
			};

		case 'resetEventObject':
			return {
				...state,
				eventObject: null,
			};
		case 'setRequesIsPending':
			return {
				...state,
				requestPending: action.payload.requestPending,
			};
		case 'setEditLetterMetadata':
			return {
				...state,
				editLetterMetadata: action.payload.editLetterMetadata,
				letterData: action.payload.letterData || state.letterData,
				letterId: (action.payload.letterData && action.payload.letterData.id)  || state.letterId,
			};
		case 'setViewMetadata':
			return {
				...state,
				viewMetadata: action?.payload?.viewMetadata,
				letterData: action.payload.letterData || state.letterData,
				letterId: (action.payload.letterData && action.payload.letterData.id)  || state.letterId,
			};

		case 'requestPending':
			console.log('request pending');
			return state;

		case 'submitLetterMetadataEdit':
			return {
				...state,
				letterData: {
					...state.letterData,
					...action.payload,
				},
				editLetterMetadata: false,
			};

		case 'resetNewChangeIdAfterRemove':
			return {
				...state,
				newChangeIdAfterRemove: null,
			};

		case 'addChangeToDict':
			return {
				...state,
				currentChangesHistory: {
					...state.currentChangesHistory,
					changes: state.currentChangesHistory.changes.map(change => {
						if (change.id === action.payload.changeId) {
							return {
								...change, inDictionary: true,
							};
						}
						return change;
					}),
				},
			};

		case 'suggestAutomaticFixes':
		case 'suggestAutomaticChanges':
			return {
				...state,
				letterData: {
					...state.letterData,
					autoChanges: action.payload.autoChanges,
					originalDoc: action.payload.originalDoc,
					simplifiedDoc: action.payload.simplifiedDoc,
					finalDoc: action.payload.finalDoc,
					version: action.payload.version,
				},
				caret: { start: 0, end: 0, text: '' },
				currentSelectedChangeId: 0,
				addToexistingMode: false,
				currentChangesHistory: null,
				popoverMode: 0,
				historyIsLoading: false,
			};

		case 'removeAutomaticChanges':
			return {
				...state,
				letterData: {
					...state.letterData,
					autoChanges: action.payload.autoChanges,
					originalDoc: action.payload.originalDoc,
					simplifiedDoc: action.payload.simplifiedDoc,
					finalDoc: action.payload.finalDoc,
					version: action.payload.version,
				},
				caret: { start: 0, end: 0, text: '' },
				currentSelectedChangeId: 0,
				addToexistingMode: false,
				currentChangesHistory: null,
				popoverMode: 0,
				historyIsLoading: false,
			};

			// toHoistChangeId
		case 'popoverMenuSelectChange':
			return {
				...state,
				letterData: {
					...state.letterData,
					originalDoc: action.payload.originalDoc,
					simplifiedDoc: action.payload.simplifiedDoc,
					finalDoc: action.payload.finalDoc,
				},
				currentChangesHistory: {
					...state.currentChangesHistory,
					...action.payload.changes,
				},
				historyIsLoading: false,
				currentSelectedChangeId: action.payload.changeId,
			};
		case 'popoverMenuSelectChangeAndDeleteRemainingAutomatic':
			return {
				...state,
				letterData: {
					...state.letterData,
					autoChanges: action.payload.autoChanges,
					originalDoc: action.payload.originalDoc,
					simplifiedDoc: action.payload.simplifiedDoc,
					finalDoc: action.payload.finalDoc,
				},
				currentChangesHistory: {
					...state.currentChangesHistory,
					...action.payload.changes,
				},
				historyIsLoading: false,
			};
		case 'setAutoChangesIsLoading':
			return {
				...state,
				autoChangesIsLoading: action.payload.autoChangesIsLoading,
			};

		default:
			return { ...state };
	}
};
export default textWrapperReducer;
